import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { SERVER_URL } from './config';
import { AppContext } from './App';
import LocationSearch from './LocationSearch';
import './Info.css';
    
const MAX_FILE_SIZE_MB = 2;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;  // 2 * 1024 * 1024 = 2,097,152 bytes

function Info() {
    const { user } = useContext(AppContext);
    const [info, setInfo] = useState({});
    const [editedInfo, setEditedInfo] = useState({});
    const [selectedFile, setSelectedFile] = useState(null); // For file upload
    const [previewUrl, setPreviewUrl] = useState(null);
    const [dates, setDates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fileError, setFileError] = useState('');



    const invitationOptions = [
        {
            serverPath: "https://mariage1234.s3.eu-central-1.amazonaws.com/image1.jpeg",
            localPath: "/image1.png",
        },
        {
            serverPath: "https://mariage1234.s3.eu-central-1.amazonaws.com/image2.jpeg",
            localPath: "/image2.png",
        },
        {
            serverPath: "https://mariage1234.s3.eu-central-1.amazonaws.com/image3.jpeg",
            localPath: "/image3.png",
        },
    ];


    useEffect(() => {
        const getInfo = async () => {
            try {
                const response = await axios.get(`${SERVER_URL}info/`, {
                    headers: {
                        Authorization: `Token ${localStorage.getItem('token')}`, // Add token here
                    },
                });
                setInfo(response.data);
                setEditedInfo(response.data);

                const withOriginal = (response.data.dates || []).map(d => ({
                    id: d.id,      
                    type: d.type,
                    date: d.date,
                    originalDate: d.date
                  }));
                  setDates(withOriginal);
                             
            } catch (error) {
                console.error('Error fetching user info:', error);
                alert('Failed to fetch user info. Please log in again.');
            }
        };
    
        getInfo();
    }, [user]);
    
    


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "message" && value.length > 300) return;
        setEditedInfo((prev) => ({ ...prev, [name]: value }));
    };

    const handleLocationSelect = (location) => {
        setEditedInfo((prev) => ({
            ...prev,
            latitude: parseFloat(location.lat.toFixed(6)),
            longitude: parseFloat(location.lng.toFixed(6)),
            address: location.name, // Save the address separately
        }));
    };

    const handleSaveAll = async () => {
        setLoading(true); // Start loading indicator

        try {
            let uploadedImageUrl = editedInfo.invitation;
    
            if (selectedFile) {
                const formData = new FormData();
                formData.append('file', selectedFile);
    
                const uploadResponse = await axios.post(`${SERVER_URL}upload/`, formData, {
                    headers: {
                        Authorization: `Token ${localStorage.getItem('token')}`, // Include token
                    },
                });
    
                uploadedImageUrl = uploadResponse.data.url; // Get the uploaded image URL
                setSelectedFile(null); // Clear the selected file after upload
                setPreviewUrl(null);
            }
    
            const massagesPayload = dates.map(d => ({
                id: d.id,
                date: d.date
              }));
              const updatedData = { 
                ...editedInfo, 
                invitation: uploadedImageUrl,
                massages: massagesPayload
              };
              
        
            await axios.post(`${SERVER_URL}info/`, updatedData, {
                headers: { Authorization: `Token ${localStorage.getItem('token')}` }, // Include token
            });
    
            setInfo(updatedData); // Update the state with the saved data
            setEditedInfo(updatedData);
            alert('כל השינויים נשמרו בהצלחה');
        } catch (error) {
            if (error.response?.status === 413) {
              setFileError(`התמונה גדולה מדי – מעל ${MAX_FILE_SIZE_MB}MB.`);
            } else {
              alert('שגיאה בשמירת השינויים');
            }
          } finally {
            setLoading(false); // Stop loading indicator
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
      
        if (file.size > MAX_FILE_SIZE) {
          alert(`התמונה גדולה מדי – מעל ${MAX_FILE_SIZE_MB}MB. בחרי קובץ קטן יותר.`);
          e.target.value = null;
          setPreviewUrl(null);
          return;
        }
      
        setSelectedFile(file);
        setPreviewUrl(URL.createObjectURL(file));
      };

        const handlePreviewClick = async () => {
          try {
            const response = await axios.get(`${SERVER_URL}send-preview-message/`, {
                headers: {
                  Authorization: `Token ${localStorage.getItem('token')}`,
                },
              });
            alert(response.data.message);
          } catch (error) {
            alert('שליחת הודעת התצוגה נכשלה.');
          }
        };      


    return (
        <div className="background">
        <div className="info-container">
            <h2>מידע אישי</h2>
            <div className="edit-form">
                <label>
                    שם פרטי:
                    <input
                        type="text"
                        name="first_name"
                        value={editedInfo.first_name || ''}
                        onChange={handleInputChange}
                    />
                </label>
                <label>
                    שם משפחה:
                    <input
                        type="text"
                        name="last_name"
                        value={editedInfo.last_name || ''}
                        onChange={handleInputChange}
                    />
                </label>
                <label>
                    שם הכלה:
                    <input
                        type="text"
                        name="bride_name"
                        value={editedInfo.bride_name || ''}
                        onChange={handleInputChange}
                    />
                </label>
                <label>
                    שם החתן:
                    <input
                        type="text"
                        name="groom_name"
                        value={editedInfo.groom_name || ''}
                        onChange={handleInputChange}
                    />
                </label>
                <label>
                    טלפון:
                    <input
                        type="text"
                        name="phone"
                        value={editedInfo.phone || ''}
                        onChange={handleInputChange}
                    />
                </label>
                <label>
                    אימייל:
                    <input
                        type="email"
                        name="email"
                        value={editedInfo.email || ''}
                        onChange={handleInputChange}
                    />
                </label>
                <label>
                    שם האולם:
                    <input
                        type="text"
                        name="hall"
                        value={editedInfo.hall || ''}
                        onChange={handleInputChange}
                    />
                </label>
                <label>
                    <span>עדכן כתובת אולם (שים לב את שם האולם יש לעדכן בנפרד):</span>
                    <LocationSearch
                        onLocationSelect={handleLocationSelect}
                        defaultValue={editedInfo.address} // Use stored address
                        />
                </label>
                <label>
                    תאריך:
                    <input
                        type="date"
                        name="date"
                        value={editedInfo.date || ''}
                        onChange={handleInputChange}
                    />
                </label>
                <label>
                    שעה:
                    <input
                        type="time"
                        name="time"
                        value={editedInfo.time || ''}
                        onChange={handleInputChange}
                    />
                </label>
                {dates.length > 0 && (
 <div className="massages-section">
              <p className="massages-text">
            תאריכי שליחת הודעות ושיחות מתוכננים:
            </p>
            {dates.map((date, index) => (
  <div key={index} className="massage-item">
    {date.type === "event_day" ? (
      <>
        <label className="massage-type">📅 הודעת תזכורת ביום האירוע</label>
        <input
          type="date"
          value={date.date}
          disabled
        />
      </>
    ) : (
      <>
        <label className="massage-type">
          {date.type === "call" ? "📞 שיחה" : "💬 הודעה"}
        </label>
        <input
          type="date"
          value={date.date}
          onChange={(e) => {
            const updatedDates = [...dates];
            updatedDates[index] = {
              ...updatedDates[index],
              date: e.target.value,
              originalDate: updatedDates[index].originalDate || updatedDates[index].date
            };
            setDates(updatedDates);
          }}
        />
      </>
    )}
  </div>
))}
</div>
)}

                <label>
                        אם ברצונכם להוסיף הערה להזמנה שתישלח רשמו אותה כאן (עד 300 תווים):
                        <textarea
                            name="message"
                            value={editedInfo.message || ''}
                            onChange={handleInputChange}
                            maxLength={300}
                        />
                    </label>
                <div>
    <label>בחר הזמנה:</label>
    <div className="invitation-options">
        {invitationOptions.map((option, idx) => (
            <div
                key={idx}
                className={`invitation-option ${
                    editedInfo.invitation === option.serverPath ? 'selected' : ''
                }`}
                onClick={() =>
                    setEditedInfo((prev) => ({ ...prev, invitation: option.serverPath }))
                }
            >
                <img src={option.localPath} alt={`Invitation ${idx + 1}`} />
            </div>
        ))}
<div className={`upload-option ${
    (!invitationOptions.some(option => option.serverPath === editedInfo.invitation) && editedInfo.invitation) ? 'selected' : ''
}`}>
    <label className="file-upload-label">
    <input
  type="file"
  name="customInvitation"
  accept="image/*"
  onChange={handleFileChange}
/>
    {selectedFile
        ? "נבחרה תמונה (לחץ להעלות תמונה חדשה)"
        : "העלה תמונה משלך"}
</label>
{previewUrl && (
    <img
        src={previewUrl}
        alt="Preview"
        style={{ maxWidth: "200px", marginTop: "8px" }}
    />
)}
</div>
    </div>
</div>
      <label>רוצה לראות את ההודעה שתישלח לאורחים שלך?
      <button onClick={handlePreviewClick}>לחץ כאן וההודעה תישלח אליך לווצאפ</button>
      </label>
<button
  className="save-all-button"
  onClick={handleSaveAll}
  disabled={loading || !!fileError}
>
  {loading ? "שומר שינויים..." : "שמור שינויים"}
</button>

{loading && (
    <div className="loading-spinner">
        ⏳ טוען... אנא המתן
    </div>
)}
            </div>
            </div>
        </div>
    );
}

export default Info;